const ORIGINAL_DESIGN_ID = 'original';

export default {
  ORIGINAL_DESIGN_ID,
};
